import copyObject from "./copyObject";
import {isBrowser} from "react-device-detect";
import {removePKFromArray} from "./removePKFromArray";
import isObjectEmpty from "./isObjectEmpty";
import API_Root from "./API_Root";
import {modifyAPIMenuItem} from "../Actions/ModifyAPIMenuItem";
import API_Root_Lambda from "./API_Root_Lambda";

const handleReadStatus = (reply, props, isImport) => {
    if (!isImport){
        let filePKProBlock = reply['filePKProBlock'];

        if (typeof props.filePKProBlock !== 'undefined'){
            if (!isObjectEmpty(props.filePKProBlock)){
                filePKProBlock = copyObject(props.filePKProBlock, reply['filePKProBlock']);
            }
        }

        props.modifyFilePKProBlock(filePKProBlock);
    }
};

const handleApiStatus = (reply, filePK, props, showTutorial, editOptions) => {
    let fileInformation = reply['fileInformation'];
    let sheetRead = reply['sheetRead'];

    if (typeof props.fileInformation !== 'undefined'){
        if (Object.entries(props.fileInformation).length !== 0 && props.fileInformation.constructor === Object){
            fileInformation = copyObject(props.fileInformation, reply.fileInformation);
            sheetRead = copyObject(props.sheetRead, reply.sheetRead);
        }
    }

    props.modifyFileInformation(fileInformation);
    props.modifySheetRead(sheetRead);

    if (editOptions){
        const reduxEditOptions = JSON.parse(JSON.stringify(props.reduxEditOptions));

        if (props.editID !== "all"){
            reduxEditOptions[props.editID] = props.editOptions;
        }
        else{
            for (let i=0; i<props.filePK.length; i++){
                const filePKObj = props.filePK[i];
                const fileID = filePKObj['id'];

                reduxEditOptions[fileID] = props.editOptions;
            }

            reduxEditOptions["all"] = props.editOptions;
        }

        props.modifyEditOptions(reduxEditOptions);
    }

    if (showTutorial){
        props.toggleModal(null)

        if (filePK.length === 1){
            const fileHash = fileInformation[filePK[0].id].fileHash
            props.navigateTo("/files/" + fileHash)
        } else if (filePK.length > 1){
            props.modifyAPIMenuItem("files")
        }
    } else {
        props.toggleModal(null)
    }
};

const handleApiPostActions = (filePK) => {
    const apiPrivateBody =
        JSON.stringify({
            email: localStorage.getItem("email"),
            token: localStorage.getItem("token"),
            pk: filePK[0].pk,
            privateStatus: true,
            getKeys: false,
            env: localStorage.getItem("env")
        })

    console.log(apiPrivateBody)
    fetch(API_Root_Lambda + "api/toggle-api-private-status/", {
        method: 'POST',
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
        body: apiPrivateBody
    }).then(r => {
        console.log(r.status)
        if (r.status !== 201) {
            console.log("error setting api private")
        }
    }).catch(err => console.log(err))

    const activeTeamHash = localStorage.getItem("activeTeamHash")
    if (activeTeamHash !== null && activeTeamHash !== undefined) {
        let req_body = {
            "resource_type": "file",
            "resource_pk": filePK[0].pk,
            "team_hash": activeTeamHash,
            "access_level": null,
            "email": localStorage.getItem("email"),
            "token": localStorage.getItem("token")
        }

        fetch(API_Root_Lambda + "api/api-spreadsheets-team-resource-access/grant", {
            method: "POST",
            body: JSON.stringify(req_body),
        }).then(res => {
            if (res.status !== 201){
                res.json().then(data => {
                    console.log(data);
                }).catch(error => console.log(error));
            } else {
                console.log("file team access granted");
            }
        }).catch(err => console.log(err));
    }
};

const handleErrorStatus = (reply, filePK, props, isUpload) => {
    props.modifyStatus("upload");
    props.toggleModal(null);

    if (isUpload){
        props.initUploadedPK(removePKFromArray(props.uploadedPK, filePK))
        props.modifyFilePK(removePKFromArray(props.filePK, filePK));
    }

    const errorMessage = 'errorMessage' in reply ? reply['errorMessage'] : "There was an error reading your file. Please try again. Contact our support if this error persists"
    props.toggleToast({show: true, message: errorMessage, type: "error"})
};

const readFilesREST = (socketRequest, filePK, props, isUpload, showTutorial, editOptions=false, isImport=false) => {
    fetch(API_Root + "api/read-api-files/", {
        method: 'POST',
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(socketRequest)
    }).then(res => res.json()).then(reply => {
        const status = reply['status'];

        if (status === "error"){
            handleErrorStatus(reply, filePK, props, isUpload);
            return;
        }

        if (status === "columnNamesError"){
            props.modifyStatus("upload");
            props.modifyModalInfo({
                infoType: "columnMap",
                columnNamesMap: reply.columnNamesMap
            })
            props.toggleModal(null)
            props.toggleModal("fixColumnNamesModal")
            return;
        }

        // For REST, we get read + api data all at once
        props.modifyStatus("read");
        handleReadStatus(reply, props, isImport);

        props.modifyStatus("api");
        handleApiStatus(reply, filePK, props, showTutorial, editOptions);
        handleApiPostActions(filePK);

    }).catch(err => {
        console.log(err);
        handleErrorStatus({}, filePK, props, isUpload);
    });
};

export const readFiles = (socketRequest, filePK, props, socketURL, isUpload, showTutorial, editOptions=false, isImport=false) => {
    if (window.location.origin.includes('localhost')) {
        readFilesREST(socketRequest, filePK, props, isUpload, showTutorial, editOptions, isImport);
        return;
    }

    // Open up WebSockets
    const websocketRoute = API_Root.substring(0, 5) === "https" ? API_Root.replace("https", "wss") : API_Root.replace("http", "ws");
    const socket = new WebSocket(websocketRoute + "ws/api/" + socketURL + "/");

    // Send the PKs and if any column names
    socket.onopen = (event) => {
        socket.send(JSON.stringify(socketRequest));
    };

    socket.onmessage = (event) => {
        const reply = JSON.parse(event.data);
        const status = reply['status'];

        if (status === "read"){
            props.modifyStatus(status);

            if (!isImport){
                let filePKProBlock = reply['filePKProBlock'];

                if (typeof props.filePKProBlock !== 'undefined'){
                    if (!isObjectEmpty(props.filePKProBlock)){
                        filePKProBlock = copyObject(props.filePKProBlock, reply['filePKProBlock']);
                    }
                }

                props.modifyFilePKProBlock(filePKProBlock);
            }
        }

        if (status === "api"){
            props.modifyStatus(status);
            let fileInformation = reply['fileInformation'];
            let sheetRead = reply['sheetRead'];

            if (typeof props.fileInformation !== 'undefined'){
                if (Object.entries(props.fileInformation).length !== 0 && props.fileInformation.constructor === Object){
                    fileInformation = copyObject(props.fileInformation, reply.fileInformation);
                    sheetRead = copyObject(props.sheetRead, reply.sheetRead);
                }
            }

            props.modifyFileInformation(fileInformation);
            props.modifySheetRead(sheetRead);

            if (editOptions){
                const reduxEditOptions = JSON.parse(JSON.stringify(props.reduxEditOptions));

                if (props.editID !== "all"){
                    reduxEditOptions[props.editID] = props.editOptions;
                }
                else{
                    for (let i=0; i<props.filePK.length; i++){
                        const filePKObj = props.filePK[i];
                        const fileID = filePKObj['id'];

                        reduxEditOptions[fileID] = props.editOptions;
                    }

                    reduxEditOptions["all"] = props.editOptions;
                }

                props.modifyEditOptions(reduxEditOptions);
            }

            if (showTutorial){
                props.toggleModal(null)

                // If multiple files then go there, otherwise go to individual files page
                if (filePK.length === 1){
                    const fileHash = fileInformation[filePK[0].id].fileHash
                    props.navigateTo("/files/" + fileHash)
                } else if (filePK.length > 1){
                    props.modifyAPIMenuItem("files")
                    // props.navigateTo("/api?menuItem=files")
                }

                // if (isBrowser){
                //     if (props.showingTutorial){
                //         if (props.tutorialStep === "userPreference"){
                //             props.toggleModal("quickStartModal")
                //         }
                //     }
                //     else{
                //         props.toggleModal(null)
                //     }
                // }
            } else {
                props.toggleModal(null)
            }

            socket.close()
        }

        if (status === "error"){
            socket.close()
            props.modifyStatus("upload");
            props.toggleModal(null);

            if (isUpload){
                props.initUploadedPK(removePKFromArray(props.uploadedPK, filePK))
                props.modifyFilePK(removePKFromArray(props.filePK, filePK));
            }

            const errorMessage = 'errorMessage' in reply ? reply['errorMessage'] : "There was an error reading your file. Please try again. Contact our support if this error persists"
            props.toggleToast({show: true, message: errorMessage, type: "error"})
        }

        if (status === "api"){
            const apiPrivateBody =
                JSON.stringify({
                    email: localStorage.getItem("email"),
                    token: localStorage.getItem("token"),
                    pk: filePK[0].pk,
                    privateStatus: true,
                    getKeys: false,
                    env: localStorage.getItem("env")
                })

            console.log(apiPrivateBody)
            fetch(API_Root_Lambda + "api/toggle-api-private-status/", {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                },
                body: apiPrivateBody
            }).then(r => {
                console.log(r.status)
                if (r.status !== 201) {
                    console.log("error setting api private")
                }
            }).catch(err => console.log(err))

            const activeTeamHash = localStorage.getItem("activeTeamHash")
            if (activeTeamHash !== null && activeTeamHash !== undefined) {
                let req_body = {
                    "resource_type": "file",
                    "resource_pk": filePK[0].pk,
                    "team_hash": activeTeamHash,
                    "access_level": null,
                    "email": localStorage.getItem("email"),
                    "token": localStorage.getItem("token")
                }

                fetch(API_Root_Lambda + "api/api-spreadsheets-team-resource-access/grant", {
                    method: "POST",
                    body: JSON.stringify(req_body),
                }).then(res => {
                    if (res.status !== 201){
                        res.json().then(data => {
                            console.log(data);
                        }).catch(error => console.log(error));
                    } else {
                        console.log("file team access granted");
                    }
                }).catch(err => console.log(err));
            }
        }


        if (status === "columnNamesError"){
            socket.close()

            props.modifyStatus("upload");

            props.modifyModalInfo({
                infoType: "columnMap",
                columnNamesMap: reply.columnNamesMap
            })

            props.toggleModal(null)
            props.toggleModal("fixColumnNamesModal")
        }
    };
}